exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-border[data-v-0aeb1ce8]{border:7px solid #0072ba;margin:3px}", ""]);

// exports
